// @flow
import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { logout } from '@context/user';
import { mapBundledPermission, canEditDoctor, mapManagesClinic } from '@helpers/connect';
import { router } from '@router';
import { withRouter } from 'react-router-dom';
import { ServiceTemplateForm as ServiceTemplateFormView } from '../components/views';
import { serviceTemplateActions } from '../redux/modules/context/serviceTemplates';
import type { Dispatch, User, Service, BundledPermissions } from '../types';


type Props = {
  dispatch: Function,
  user: User,
  doctorId: number,
  permissions: BundledPermissions,
  doctorName: string,
  isManager: boolean,
  canEditDoctorServices: boolean,
};

const queryFlag = (props: Object, name: string): boolean => (
  new URLSearchParams(get(props, ['location', 'search'], '')).get(name) === 'true'
);

class ServiceTemplateNewForm extends React.Component<Props> {
  render() {
    const {
      user, doctorId, doctorName, isManager, canEditDoctorServices,
    } = this.props;

    const healthInsurance = queryFlag(this.props, 'insurance');
    const shared = queryFlag(this.props, 'shared');

    return (
      <ServiceTemplateFormView
        onSave={this.handleSaveService}
        doctorId={doctorId}
        user={user}
        onLogout={this.handleLogout}
        permissions={this.props.permissions}
        onCancel={this.handleBack}
        isSaving={get(this.props, ['services', 'isSaving'], false)}
        shared={shared}
        doctorName={doctorName}
        canEdit={shared ? isManager : canEditDoctorServices}
        formData={{
          healthInsurance,
        }}
      />
    );
  }

  handleBack = () => this.props.dispatch(router.pushPath('serviceTemplatesList', { doctorId: this.props.doctorId }));

  handleLogout = () => this.props.dispatch(logout());

  handleSaveService = (data: Service) => {
    const { dispatch, doctorId } = this.props;
    dispatch(serviceTemplateActions.createServiceTemplate(doctorId, queryFlag(this.props, 'shared') ? { ...data, shared: true } : data));
  };
}

const mapStateToProps = (state, ownProps) => ({
  services: state.context.serviceTemplates,
  user: state.context.user,
  doctorId: get(ownProps, ['match', 'params', 'doctorId']),
  permissions: mapBundledPermission(state),
  doctorName: get(state, ['context', 'doctors', 'data', String(get(ownProps, ['match', 'params', 'doctorId'])), 'nameWithTitle'], ''),
  isManager: mapManagesClinic(state),
  canEditDoctorServices: canEditDoctor(state, get(ownProps, ['match', 'params', 'doctorId'])),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ServiceTemplateNewForm));
